import {
  Box,
  ToggleButton as MuiToggleButton,
  type ToggleButtonProps as MuiToggleButtonProps,
} from "@mui/material";

import { CbhIcon, type IconType } from "../CbhIcon";

interface ToggleButtonProps extends MuiToggleButtonProps {
  iconType?: IconType;
}

export function ToggleButton(props: ToggleButtonProps) {
  const { iconType, children, ...restProps } = props;

  return (
    <MuiToggleButton {...restProps}>
      {iconType && <CbhIcon type={iconType} size="small" sx={{ mr: 3, flexShrink: 0 }} />}

      <Box component="span" sx={{ flexGrow: 1 }}>
        {children}
      </Box>
    </MuiToggleButton>
  );
}
